<template>
<div class="mx-10 mt-5 cgu-body" >
  <div v-html="content"></div>
</div>
</template>

<script lang='ts'>
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})

export default class CGUBody extends Vue {
  @Prop()
  public isActive: boolean | undefined;
  @Prop()
  public content: any | undefined;

  get dialogState(): boolean {
    return !!this.isActive;
  }
}
</script>

<style lang="stylus">
.cgu-body {
  overflow-y: auto;
  height: 300px;

  div {
    padding: 8px;
    h3 {
      color: #1C52A6
      padding: 3px 0px;
    }
    h4 {
      color: #1C52A6
    }
    p {
      text-align justify
    }
  }
}
</style>
